// frontend/src/data/dsaRoadmap.js
export const dsaRoadmap = {
  levels: [
    {
      id: 'beginner',
      title: 'Beginner',
      topics: [
        {
          id: '1.1',
          title: 'Basics',
          subtopics: [
            { id: '1.1.1', title: 'Time/Space Complexity' },
            { id: '1.1.2', title: 'Big-O Notation' },
            { id: '1.1.3', title: 'GCD, LCM, Primes, Modulo' }
          ]
        },
        {
          id: '1.2',
          title: 'Data Types & Operations',
          subtopics: [
            { id: '1.2.1', title: 'Arrays Fundamentals' },
            { id: '1.2.2', title: 'Strings Manipulation' },
            { id: '1.2.3', title: 'Simple Loops & Patterns' },
            { id: '1.2.4', title: 'Sliding Window Basics' },
            { id: '1.2.5', title: 'HashMap/Dictionary Basics' }
          ]
        }
      ]
    },
    {
      id: 'beginner-intermediate',
      title: 'Beginner → Intermediate',
      topics: [
        {
          id: '2.1',
          title: 'Prefix/Suffix',
          subtopics: [
            { id: '2.1.1', title: 'Prefix Sum' },
            { id: '2.1.2', title: 'Suffix Sum' },
            { id: '2.1.3', title: 'Prefix XOR' },
            { id: '2.1.4', title: 'Difference Array' },
            { id: '2.1.5', title: 'Running Max/Min' }
          ]
        },
        {
          id: '2.2',
          title: 'Two Pointers',
          subtopics: [
            { id: '2.2.1', title: 'Opposite Pointers' },
            { id: '2.2.2', title: 'Same Direction' },
            { id: '2.2.3', title: 'Slow-Fast (Floyd Cycle)' }
          ]
        },
        {
          id: '2.3',
          title: 'Sorting Logic',
          subtopics: [
            { id: '2.3.1', title: 'Custom Sorting' },
            { id: '2.3.2', title: 'Greedy + Sorting' },
            { id: '2.3.3', title: 'Sweep Line' }
          ]
        },
        {
          id: '2.4',
          title: 'Recursion Foundation',
          subtopics: [
            { id: '2.4.1', title: 'Recursion Types' },
            { id: '2.4.2', title: 'Parameter vs Functional Recursion' },
            { id: '2.4.3', title: 'Print Subsequences' },
            { id: '2.4.4', title: 'Backtracking Intro' }
          ]
        }
      ]
    },
    {
      id: 'intermediate',
      title: 'Intermediate',
      topics: [
        {
          id: '3.1',
          title: 'Stack & Queue',
          subtopics: [
            { id: '3.1.1', title: 'Monotonic Stack' },
            { id: '3.1.2', title: 'Monotonic Queue' },
            { id: '3.1.3', title: 'Next Greater Element' },
            { id: '3.1.4', title: 'Sliding Window Max' }
          ]
        },
        {
          id: '3.2',
          title: 'Linked List',
          subtopics: [
            { id: '3.2.1', title: 'Reverse Linked List' },
            { id: '3.2.2', title: 'K-Group Reverse' },
            { id: '3.2.3', title: 'Merge Sorted Lists' },
            { id: '3.2.4', title: 'Fast-Slow Patterns' }
          ]
        },
        {
          id: '3.3',
          title: 'Binary Search',
          subtopics: [
            { id: '3.3.1', title: 'Binary Search Basics' },
            { id: '3.3.2', title: 'Binary Search on Answer' },
            { id: '3.3.3', title: 'Lower/Upper Bound' },
            { id: '3.3.4', title: 'Peak Element' },
            { id: '3.3.5', title: 'Rotated Sorted Array' }
          ]
        },
        {
          id: '3.4',
          title: 'Backtracking Core',
          subtopics: [
            { id: '3.4.1', title: 'Permutations' },
            { id: '3.4.2', title: 'Combinations' },
            { id: '3.4.3', title: 'Subsets' },
            { id: '3.4.4', title: 'Rat in Maze' },
            { id: '3.4.5', title: 'Sudoku Solver' },
            { id: '3.4.6', title: 'N-Queens' }
          ]
        }
      ]
    },
    {
      id: 'data-structure-heavy',
      title: 'Data Structure Heavy',
      topics: [
        {
          id: '4.1',
          title: 'Trees',
          subtopics: [
            { id: '4.1.1', title: 'Tree Traversals' },
            { id: '4.1.2', title: 'Level Order' },
            { id: '4.1.3', title: 'Diameter of Tree' },
            { id: '4.1.4', title: 'Lowest Common Ancestor' },
            { id: '4.1.5', title: 'BST Operations' },
            { id: '4.1.6', title: 'Tree Serialization' },
            { id: '4.1.7', title: 'Tree DP' }
          ]
        },
        {
          id: '4.2',
          title: 'Graphs',
          subtopics: [
            { id: '4.2.1', title: 'DFS/BFS' },
            { id: '4.2.2', title: 'Cycle Detection' },
            { id: '4.2.3', title: 'Topological Sort' },
            { id: '4.2.4', title: 'Connected Components' },
            { id: '4.2.5', title: 'Bipartite Graph' },
            { id: '4.2.6', title: "Dijkstra's Algorithm" },
            { id: '4.2.7', title: 'Prim/Kruskal' },
            { id: '4.2.8', title: 'Flood Fill' },
            { id: '4.2.9', title: 'Graph Coloring' },
            { id: '4.2.10', title: 'Disjoint Set Union' }
          ]
        },
        {
          id: '4.3',
          title: 'Heap & Priority Queue',
          subtopics: [
            { id: '4.3.1', title: 'Min/Max Heap' },
            { id: '4.3.2', title: 'K Largest/Smallest' },
            { id: '4.3.3', title: 'Median of Data Stream' },
            { id: '4.3.4', title: 'Task Scheduling' }
          ]
        },
        {
          id: '4.4',
          title: 'Trie',
          subtopics: [
            { id: '4.4.1', title: 'Trie Insert/Search' },
            { id: '4.4.2', title: 'Prefix Search' },
            { id: '4.4.3', title: 'Word Break' },
            { id: '4.4.4', title: 'Auto-complete' }
          ]
        }
      ]
    },
    {
      id: 'advanced',
      title: 'Advanced Algorithms',
      topics: [
        {
          id: '5.1',
          title: 'Dynamic Programming',
          subtopics: [
            { id: '5.1.1', title: '0/1 Knapsack' },
            { id: '5.1.2', title: 'Unbounded Knapsack' },
            { id: '5.1.3', title: 'Grid DP' },
            { id: '5.1.4', title: 'Subsequence DP' },
            { id: '5.1.5', title: 'String DP' },
            { id: '5.1.6', title: 'Space Optimization' },
            { id: '5.1.7', title: 'Bitmask DP' },
            { id: '5.1.8', title: 'Digit DP' },
            { id: '5.1.9', title: 'Tree DP' }
          ]
        },
        {
          id: '5.2',
          title: 'Advanced Graphs',
          subtopics: [
            { id: '5.2.1', title: 'Bellman-Ford' },
            { id: '5.2.2', title: 'Floyd-Warshall' },
            { id: '5.2.3', title: 'Bridges/Articulation Points' },
            { id: '5.2.4', title: 'Strongly Connected Components' },
            { id: '5.2.5', title: 'Topological DP' },
            { id: '5.2.6', title: 'Euler Tour' },
            { id: '5.2.7', title: 'Binary Lifting' },
            { id: '5.2.8', title: 'Advanced LCA' }
          ]
        },
        {
          id: '5.3',
          title: 'Segment/Fenwick Trees',
          subtopics: [
            { id: '5.3.1', title: 'Range Queries' },
            { id: '5.3.2', title: 'Range Updates' },
            { id: '5.3.3', title: 'Lazy Propagation' },
            { id: '5.3.4', title: 'Fenwick Tree' },
            { id: '5.3.5', title: 'RMQ/RSQ' }
          ]
        },
        {
          id: '5.4',
          title: 'Advanced Greedy',
          subtopics: [
            { id: '5.4.1', title: 'Activity Selection' },
            { id: '5.4.2', title: 'Gas Station Problem' },
            { id: '5.4.3', title: 'Hard Scheduling' },
            { id: '5.4.4', title: 'Minimum Jumps' },
            { id: '5.4.5', title: 'Greedy + DP' }
          ]
        }
      ]
    },
    {
      id: 'competitive',
      title: 'Competitive Mixed',
      topics: [
        {
          id: '6.1',
          title: 'Mixed Logic',
          subtopics: [
            { id: '6.1.1', title: 'DP + Prefix' },
            { id: '6.1.2', title: 'Graph + DP' },
            { id: '6.1.3', title: 'Greedy + Heap' },
            { id: '6.1.4', title: 'Hash + Sliding Window + Two Pointers' },
            { id: '6.1.5', title: 'Bitmask + Recursion' },
            { id: '6.1.6', title: 'Tree + DFS + Binary Search' },
            { id: '6.1.7', title: 'Graph + Binary Search' },
            { id: '6.1.8', title: 'DSU + Graph + Sorting' }
          ]
        },
        {
          id: '6.2',
          title: 'CP Patterns',
          subtopics: [
            { id: '6.2.1', title: 'Meet in the Middle' },
            { id: '6.2.2', title: 'Sqrt Decomposition' },
            { id: '6.2.3', title: "MO's Algorithm" },
            { id: '6.2.4', title: 'Offline Queries' },
            { id: '6.2.5', title: 'Heavy Light Decomposition' },
            { id: '6.2.6', title: 'Grundy Theory' }
          ]
        }
      ]
    }
  ]
};

// Available languages for DSA examples
export const availableLanguages = [
  { id: 'javascript', name: 'JavaScript', icon: '🟨' },
  { id: 'python', name: 'Python', icon: '🐍' },
  { id: 'java', name: 'Java', icon: '☕' },
  { id: 'cpp', name: 'C++', icon: '➕' },
  { id: 'solidity', name: 'Solidity', icon: '🔗' }
];

// Platform styles for problem generation
export const platformStyles = [
  { id: 'leetcode', name: 'LeetCode Style', color: '#FFA116' },
  { id: 'codeforces', name: 'Codeforces Style', color: '#3C5D8F' },
  { id: 'codechef', name: 'CodeChef Style', color: '#5C4033' },
  { id: 'atcoder', name: 'AtCoder Style', color: '#222222' }
];

// Difficulty levels
export const difficultyLevels = [
  { id: 'easy', name: 'Easy', color: '#28a745' },
  { id: 'medium', name: 'Medium', color: '#ffc107' },
  { id: 'hard', name: 'Hard', color: '#dc3545' }
];